import { z } from 'zod'

export const envSchema = z.object({
  algolia: z.object({
    apiKey: z.string(),
    appID: z.string(),
    index: z.object({
      specialtyDoctor: z.string(),
      local: z.string(),
      healthCarrier: z.string(),
      healthPlan: z.string()
    })
  }),
  patientArea: z.object({
    baseUrl: z.string().url(),
    login: z.string().url(),
    clientId: z.string(),
    refreshTokenUrl: z.string().url()
  }),
  publicUrl: z.string(),
  agHistoryBaseUrl: z.string(),
  niceChatToken: z.string(),
  recaptchaToken: z.string(),
  doctorAvatarUrlBase: z.string(),
  bannerAppAPUrl: z.string().optional(),
  bannerAppIOSUrl: z.string().optional(),
  apiClientId: z.string(),
  apiHealthCardAIClientId: z.string(),
  apiBaseUrl: z.string().url(),
  apiHealthCardAIUrl: z.string().url(),
  apiScheduleSocketBaseUrl: z.string().url(),
  apiScheduleSocketAuth: z.string(),
  apiGoogleMaps: z.string(),
  gtmId: z.string(),
  mixPanelToken: z.string(),
  apmRumServer: z.string().url(),
  whatsAppNumber: z.string(),
  scheduleLeadWebhook: z.object({
    active: z.boolean(),
    utmSource: z.string(),
    token: z.string(),
    gaCookieName: z.string()
  }),
  sentryDSN: z.string(),
  billingFraudWebsiteLink: z.string().url()
})
